import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    padding: 16px 26px 26px;
`;

export const Ul = styled.ul`
    margin: 16px 0 0;
    padding: 0 0 0 23px;

    list-style: initial;

    li {
        margin: 0 0 4px;

        .ovpn-text {
            display: inline;
        }

        &:last-of-type {
            margin: 0;
        }
    }
`;
